import { useState, useEffect } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import GridPage from "../components/GridPage";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import { tariffMasterHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import TariffMasterPopup from "../popup-containers/TariffMasterpopup";
import PopUpButtons from "../components/PopUpButtons";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import "react-datepicker/dist/react-datepicker.css";

import TextArea from "../ReusableComponents/TextArea";
import Loader from "../ReusableComponents/Loader";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { format } from "date-fns";

const TariffMaster1 = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpData, setPopUpData] = useState({});
  const [popUpDataDD, setPopUpDataDD] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  //  const [rowIndex, setRowIndex] = useState("");

  var mstClientId = sessionStorage.getItem("MstClientId");

  const createdBy = sessionStorage.getItem("createdBy");
  const [mstTariffId, setMstTariffId] = useState("");
  const [bindRoomType, setBindRoomType] = useState([]);
  const [bindTariffMaster, setBindTariffMasterData] = useState([]);

  const [formFields, setFormFields] = useState({
    roomType: "",
    baseTariff: "",
    holidayTariff: "",
    specialTariff: "",
    wef: "",
    description: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    roomTypeError: "",
    baseTariffError: "",
    holidayTariffError: "",
    specialTariffError: "",
    wefError: "",
    descriptionError: "",
  });

  useEffect(() => {
    BindTariffMaster();
  }, []);

  const BindTariffMaster = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    setIsLoading(true); 
    const response = await BindPostAPI(data, "TariffAPI/BindTariff");

    if (response && response.data) {
      setBindTariffMasterData(response.data.Table);

      const RoomTypeData = response.data.Table1.map((item) => ({
        value: item.MstRoomtypeId,
        label: item.RoomType,
      }));

      setBindRoomType(RoomTypeData);
      setIsLoading(false); 
    } else {
      setBindRoomType([]);
    }
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  const validateForm = () => {
    const errors = {
      roomTypeError: formFields.roomType ? "" : "Select Room Type",
      baseTariffError: formFields.baseTariff ? "" : "Enter Base Tariff",
      holidayTariffError: formFields.holidayTariff
        ? ""
        : "Enter Holiday Tariff",
      // specialTariffError: formFields.specialTariff
      //   ? ""
      //   : "Enter Special Tariff",
      wefError: formFields.wef ? "" : "Enter WEF",
    };

    setFormFieldsError(errors);
    return Object.values(errors).every((err) => err === "");
  };

  const handleSubmit = async (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setSubmitBtnDisabled(true);
    const isValid = validateForm();
    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(true);
      }
      if (isValid) {
        setIsLoading(true);
        const data = {
          mstTariffId: mstTariffId ? mstTariffId : 0,
          mstClientId: mstClientId,
          mstRoomTypeId: parseInt(formFields.roomType) || 0,
          baseTariff: parseInt(formFields.baseTariff) || 0,
          holidayTariff: parseInt(formFields.holidayTariff) || 0,
          // specialTariff: parseInt(formFields.specialTariff) || 0,
          wef: formFields.wef,
          description: formFields.description || "",
          createdBy: parseInt(createdBy) || 0,
          flag: flag,
        };
        const response = await IUDAPI(data, "TariffAPI/IUDTariff");
        if (flag == 1) {
          if (response?.data?.Table[0].Result === "S") {
            toast.success(
              "Tariff data inserted successfully! 👍",
              console.log("Submitting:", response),
              {
                duration: 1000,
                position: "top-center",
              }
            );
            setTimeout(cancel, 1000);
          } else {
            toast.error("Tariff data insert failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Tariff data modified successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Tariff data modification failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      const data = {
        mstTariffId: mstTariffId, // Here rowIndex is actually tariffId now
        createdBy: parseInt(createdBy, 10),
        flag: flag,
      };
      const response = await IUDAPI(data, "TariffAPI/IUDTariff");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Tariff data deleted successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to delete Tariff data. 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Tariff data Inactivated successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Tariff data Inactivated failed !👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Tariff data activated successfully! 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Tariff data activated failed! 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
      setSubmitBtnDisabled(false); 
      cancel();
    }
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
    setFormFields({
      roomType: "",
      baseTariff: "",
      holidayTariff: "",
      specialTariff: "",
      wef: "",
      description: "",
    });
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
  };

  const cancel = () => {
    BindTariffMaster();
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setVisibleAdd(false);
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    setMstTariffId("");
    setFormFields({
      roomType: "",
      baseTariff: "",
      holidayTariff: "",
      specialTariff: "",
      wef: "",
      description: "",
    });
    setFormFieldsError({
      roomTypeError: "",
      baseTariffError: "",
      holidayTariffError: "",
      specialTariffError: "",
      wefError: "",
      descriptionError: "",
    });
    setpopUpOpen(false);
  };

  const handleTariff = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
      setRowIndex(rowIndex);
    }

    const rowData = bindTariffMaster[rowIndex];
    setMstTariffId(bindTariffMaster[rowIndex].MstTariffId);

    setPopUpData(rowData);
    setPopUpDataDD(bindRoomType);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (value.trim() === "") {
      const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
      error = `${formattedName} is required`;
    }

    formFieldsError((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleEdit = (rowIndex) => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstTariffId(bindTariffMaster[rowIndex].MstTariffId);
    const formatted = bindTariffMaster[rowIndex]?.WEF
      ? format(new Date(bindTariffMaster[rowIndex].WEF), "yyyy-MM-dd")
      : "";
    setFormFields({
      ...formFields,
      roomType: bindTariffMaster[rowIndex].MstRoomTypeId,
      baseTariff: bindTariffMaster[rowIndex].BaseTariff,
      holidayTariff: bindTariffMaster[rowIndex].HolidayTariff,
      specialTariff: bindTariffMaster[rowIndex].SpecialTariff,
      wef: formatted,
      description: bindTariffMaster[rowIndex].Description,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDropdownChange = (name, value) => {
    setFormFields((prev) => ({
      ...prev,
      [name]: value.target.value,
    }));
  };
  const handleValidationAndSubmit = () => {
    const errorsObj = {};

    if (
      !formFields.roomType ||
      !/^[A-Za-z ]{3,30}$/.test(formFields.roomType)
    ) {
      errorsObj.roomType =
        "Enter a valid room Type (letters only, 3–30 characters)";
    }

    if (
      !formFields.baseTariff ||
      !/^\d+(\.\d{1,2})?$/.test(formFields.baseTariff)
    ) {
      errorsObj.baseTariff = "Enter a valid number (up to 2 decimal places)";
    }

    if (
      !formFields.specialTariff ||
      !/^\d+(\.\d{1,2})?$/.test(formFields.specialTariff)
    ) {
      errorsObj.specialTariff = "Enter a valid number (up to 2 decimal places)";
    }

    if (Object.keys(errorsObj).length > 0) {
      setFormFieldsError((prev) => ({ ...prev, ...errorsObj }));
      return;
    }

    const payload = {
      ...formFields,
      wef: formFields.wef?.toISOString?.().split("T")[0] || formFields.wef,
    };

    console.log("Submitted Tariff:", payload);
    cancel();
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Tariff"
          header={tariffMasterHeader}
          records={bindTariffMaster}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleTariff}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <>
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Tariff"
              />
            </div>
          </div>

          <div className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit sm:min-h-fit sm:max-h-fit">
            <div className={mainTable.grid3}>
              <DropDown
                name="roomType"
                title="Room Type"
                classStar="text-red-500"
                selectedOption={formFields?.roomType}
                options={bindRoomType}
                placeholder="Select Room Type"
                // tabIndex="1"
                disabled={false}
                controlFunc={(val) => handleDropdownChange("roomType", val)}
                errorMessage={formFieldsError.roomTypeError}
                controlFuncBlur={() => {
                  setFormFieldsError((prev) => ({
                    ...prev,
                    roomTypeError: formFields?.roomType
                      ? ""
                      : "Select Room Type",
                  }));
                }}
              />

              <InputText
                title="Base Tariff"
                inputType="number"
                name="baseTariff"
                classStar="text-red-500"
                content={formFields?.baseTariff}
                errorMessage={formFieldsError.baseTariffError}
                controlFunc={handleInputChange}
                maxLength="6"
                controlFuncBlur={() => {
                  const value = formFields.baseTariff;
                  let error = "";

                  if (!value) {
                    error = "Enter Base Tariff";
                  } else if (!/^\d*\.?\d*$/.test(value)) {
                    error = "Only valid numbers allowed";
                  }

                  setFormFieldsError((prev) => ({
                    ...prev,
                    baseTariffError: error,
                  }));
                }}
              />

              <InputText
                inputType="number"
                title="Holiday Tariff"
                name="holidayTariff"
                placeholder="Enter Holiday Amount"
                maxLength="6"
                classStar="text-red-500"
                content={formFields?.holidayTariff}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const isValid = /^\d+(\.\d{1,2})?$/.test(
                    formFields?.holidayTariff
                  );
                  setFormFieldsError((prev) => ({
                    ...prev,
                    holidayTariffError: formFields?.holidayTariff
                      ? isValid
                        ? ""
                        : "Enter a valid amount"
                      : "Enter Holiday Tariff",
                  }));
                }}
                errorMessage={formFieldsError.holidayTariffError}
                disabled={false}
              />

              {/* <InputText
                inputType="number"
                title="Special Tariff"
                name="specialTariff"
                maxLength="6"
                placeholder="Enter Special Amount"
                classStar="text-red-500"
                content={formFields?.specialTariff}
                controlFunc={handleInputChange}
                controlFuncBlur={() => {
                  const isValid = /^\d+(\.\d{1,2})?$/.test(
                    formFields?.specialTariff
                  );
                  setFormFieldsError((prev) => ({
                    ...prev,
                    specialTariffError: formFields?.specialTariff
                      ? isValid
                        ? ""
                        : "Enter a valid amount"
                      : "Enter Special Tariff",
                  }));
                }}
                errorMessage={formFieldsError.specialTariffError}
                disabled={false}
              /> */}

              <InputText
                inputType="date"
                title="With Effect From"
                name="wef"
                content={formFields?.wef}
                classStar={"text-red-500"}
                controlFunc={handleInputChangeForm}
                controlFuncBlur={() => {
                  setFormFieldsError((prev) => ({
                    ...prev,
                    wefError: formFields?.wef ? "" : "Enter WEF",
                  }));
                }}
                errorMessage={formFieldsError.wefError}
              />

              {/* Description Text Area */}
              {/* <div className="px-3 mt-3"> */}
            </div>
            <TextArea
              title="Description"
              rows={3}
              name="description"
              content={formFields?.description}
              placeholder="Description"
              // tabIndex="1"
              maxLength={500}
              controlFunc={handleInputChange}
              errorMessage={formFieldsError.descriptionError}
            />
          </div>

          <div className="flex justify-center mt-6">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              handleSubmit={handleSubmit}
              cancel={cancel}
              disabledBtn={submitBtnDisabled}
              viewSaveButton={false}
            />
          </div>
        </>
      )}
       {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleTariff}
      >
        <div>
          <PopUpScreenTitle
            title="Tariff"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <TariffMasterPopup data={popUpData} data1={popUpDataDD} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          disabledBtn={submitBtnDisabled}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default TariffMaster1;
